/* eslint-disable @next/next/no-before-interactive-script-outside-document */
import { memo } from 'react';
import Script from 'next/script';
import { AnalyticsPixelId } from 'core/analytics/entities';
import { FacebookScriptsService } from 'core/analytics/services';
import { CustomAppEvents } from 'core/common/entities';
import { areArraysOfPrimitivesEqual } from 'core/common/utils/areArraysOfPrimitivesEqual';
import { prepareHtml } from 'core/common/utils/prepareHtml';

export type FacebookScriptsProps = {
  ids: Array<AnalyticsPixelId>;
};

export const FacebookScripts = ({ ids }: FacebookScriptsProps) => {
  return (
    <>
      {ids.map((id: string) => {
        return (
          <Script
            id={`facebook-pixel-${id}`}
            key={`facebook-pixel-${id}`}
            strategy="beforeInteractive"
            dangerouslySetInnerHTML={prepareHtml(FacebookScriptsService.getPixelCode())}
            onReady={() => {
              const event = new Event(CustomAppEvents.FACEBOOK_PIXEL_LOADED);
              document.dispatchEvent(event);
            }}
          />
        );
      })}
    </>
  );
};

export default memo(FacebookScripts, (prevProps, nextProps) =>
  areArraysOfPrimitivesEqual(prevProps.ids, nextProps.ids),
);
